<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['send']);

const { t } = useI18n();
const content = ref('');

const submit = () => {
  const value = content.value.trim();
  if (!value || props.disabled) return;
  emit('send', value);
  content.value = '';
};

const onKeydown = event => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    submit();
  }
};
</script>

<template>
  <div class="px-4 py-3 border-t shrink-0 border-n-weak bg-n-surface-1">
    <div
      class="flex gap-2 items-end p-1.5 rounded-2xl border transition-colors bg-n-surface-1 border-n-weak focus-within:border-n-brand focus-within:ring-2 focus-within:ring-n-brand/30"
    >
      <textarea
        v-model="content"
        rows="1"
        maxlength="5000"
        :disabled="disabled"
        :placeholder="t('INTERNAL_CHAT.COMPOSER.PLACEHOLDER')"
        class="flex-1 px-2.5 py-1.5 max-h-32 text-sm bg-transparent resize-none text-n-slate-12 placeholder:text-n-slate-10 focus:outline-none"
        @keydown="onKeydown"
      />
      <button
        type="button"
        :disabled="disabled || !content.trim()"
        class="flex justify-center items-center text-white rounded-xl transition-colors size-9 shrink-0 bg-n-brand hover:bg-n-brand/90 disabled:opacity-40 disabled:cursor-not-allowed"
        :aria-label="t('INTERNAL_CHAT.COMPOSER.SEND')"
        @click="submit"
      >
        <span class="i-lucide-send-horizontal size-4" />
      </button>
    </div>
  </div>
</template>
